import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import { AiNoticeSource } from "components/ai_chat/types";
import { useRestricedViewNotice } from "lib/hooks/useRestrictedRowClick";
import { useAiContext } from "lib/providers/AiContextProvider";
import { EventNames, useTracking } from "lib/tracking";
import { createReferenceLinkOpenedEventPayload } from "./tracking";

type Props = {
  source: AiNoticeSource;
};

export default function NoticeSource({ source }: Props) {
  const { logEvent } = useTracking();
  const { viewRecord: showNotice } = useRestricedViewNotice("Source click");
  const { resourceId, resourceType } = useAiContext();

  const handleSourceClick = (source: AiNoticeSource) => {
    showNotice(source.id);
    logEvent(
      EventNames.referenceLinkOpened,
      createReferenceLinkOpenedEventPayload({
        source,
        resourceType,
        resourceId,
      }),
    );
  };

  return (
    <Flex column gap={8}>
      <Text bold>{source.title}</Text>
      {/* TODO: Add snippet */}
      <MentionsText onClick={() => handleSourceClick(source)}>View source</MentionsText>
    </Flex>
  );
}

const MentionsText = styled(Text)(({ theme }) => ({
  color: theme.colors.sysPrimaryDefault,
  cursor: "pointer",
}));
